import React, { useState, useRef, useEffect } from "react";

// Slider component tái sử dụng
export function Slider({ label, value, setValue, min, max, unit, type }) {
  const barRef = useRef(null);
  const draggingRef = useRef(false);
  const [isDragging, setIsDragging] = useState(false);

  // Helper để lấy màu gradient theo type và value
  const getColor = (value, min, max, type) => {
    const percent = (value - min) / (max - min);
    if (type === "rate") {
      if (percent < 0.5) return `rgb(255, ${Math.round(255 * percent * 2)}, 0)`; // đỏ → vàng
      return `rgb(${Math.round(255 * (1 - percent) * 2)}, 255, 0)`; // vàng → xanh
    }
    if (type === "volume") {
      return `rgb(25, ${Math.round(200 * percent + 55)}, 84)`; // xanh nhạt → xanh đậm
    }
    if (type === "pitch") {
      if (percent < 0.5) return `rgb(${Math.round(128 * percent * 2)}, 0, 128)`; // tím nhạt
      return `rgb(0, ${Math.round(200 * (percent-0.5)*2 + 55)}, 255)`; // hồng → xanh
    }
    return "#0d6efd";
  };

  const updateValue = (clientX) => {
    if (!barRef.current) return;
    const rect = barRef.current.getBoundingClientRect();
    let x = clientX - rect.left;
    if (x < 0) x = 0;
    if (x > rect.width) x = rect.width;
    const newValue = Math.round((x / rect.width) * (max - min) + min);
    setValue(newValue);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    draggingRef.current = true;
    setIsDragging(true);
    updateValue(e.clientX);
  };
  const handleMouseMove = (e) => {
    if (draggingRef.current) requestAnimationFrame(() => updateValue(e.clientX));
  };
  const handleMouseUp = () => {
    draggingRef.current = false;
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    draggingRef.current = true;
    setIsDragging(true);
    updateValue(e.touches[0].clientX);
  };
  const handleTouchMove = (e) => {
    if (draggingRef.current) requestAnimationFrame(() => updateValue(e.touches[0].clientX));
  };
  const handleTouchEnd = () => {
    draggingRef.current = false;
    setIsDragging(false);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleTouchMove, { passive: false });
    window.addEventListener("touchend", handleTouchEnd);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  const percent = ((value - min) / (max - min)) * 100;
  const color = getColor(value, min, max, type);

  return (
    <div className="my-2">
      <label className="form-label">{label}</label>
      <div
        ref={barRef}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
        style={{
          position: "relative",
          height: "12px",
          background: "#e0e0e0",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        {/* Fill gradient */}
        <div
          style={{
            position: "absolute",
            height: "100%",
            width: `${percent}%`,
            borderRadius: "6px",
            background: `linear-gradient(90deg, ${color} 0%, #fff 100%)`,
            transition: isDragging ? "none" : "width 0.1s ease-out",
          }}
        ></div>

        {/* Thumb với glow */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: `${percent}%`,
            transform: `translate(-50%, -50%) scale(${isDragging ? 1.5 : 1})`,
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            background: color,
            border: `2px solid #fff`,
            boxShadow: isDragging
              ? `0 0 12px ${color}, 0 0 20px ${color}80`
              : "0 2px 6px rgba(0,0,0,0.3)",
            transition: "transform 0.1s, background 0.1s, box-shadow 0.1s",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Tooltip */}
          {isDragging && (
            <div
              style={{
                position: "absolute",
                top: "-30px",
                background: "#000",
                color: "#fff",
                padding: "2px 6px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                transform: "translateX(-50%)",
              }}
            >
              {value > 0 ? `+${value}${unit}` : `${value}${unit}`}
            </div>
          )}
        </div>
      </div>

      <div style={{ marginTop: "5px", fontWeight: "500" }}>
        {value > 0 ? `+${value}${unit}` : `${value}${unit}`}
      </div>
    </div>
  );
}

export default Slider;
